import { axiosSwagger } from "@/axios";

export const state = {
    pending: {
        loading: false,
        data: [],
        total: 0,
    },

}


export const getters = {
}


export const mutations = {
    loading: (state, loading) => {
        state.pending.loading = loading;
    },
    setData: (state, data) => {
        state.pending.data = data;
    },
    setTotal: (state, total) => {
        state.pending.total = total;
    },
    remove: (state, id) => {
        state.pending.data = state.pending.data.filter((el) => el.id !== id);
    },
    update: (state, data) => {
        const index = state.pending.data.findIndex(
            (item) => item.id === data.id
        );

        if (index !== -1) {
            state.pending.data[index].accessLevel = data.accessLevel;
            state.pending.data[index].accessLevelId = data.accessLevelId;
            state.pending.data[index].isClassified = data.isClassified;

            // update nested file posting data
            let filePostingItem = state.pending.data[index].fileManager.filePostings.find(x => x.fileManagerId === data.fileManagerId);

            filePostingItem.accessLevel = data.accessLevel;
            filePostingItem.accessLevelId = data.accessLevelId;
            filePostingItem.isClassified = data.isClassified;
        }
    },
}


export const actions = {
    // FILE PENDING
    async readPendingPost({ commit }, id) {
        commit("loading", true);

        return await axiosSwagger
        .get(`/api/FilePosting/Pending/My/${id}`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    async readTotalAdminPendingPostResponse({ commit }, id) {
        return await axiosSwagger
        .get(`/api/FilePosting/Pending/My/${id}`)
        .then((response) => {
            commit("setTotal", response.data.length);

            return response;
        });
    },
    async updateApprovedPost({ commit }, id) {
        return await axiosSwagger
        .put(`/api/FilePosting/Approve/${id}`)
        .then((response) => {
            commit('remove', id);

            return response;
        });
    },
    async updateReturnFilePost({ commit }, id) {
        return await axiosSwagger
        .put(`/api/FilePosting/Return/${id}`)
        .then((response) => {
            commit('remove', id);

            return response;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async updateFilePosting({ commit }, data) {
        return await axiosSwagger
        .put(`/api/FilePosting/Update/${data.id}`, data)
        .then((response) => {
            commit('update', data);

            return response;
        });
    },
}